import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { QrCodeData, QrCodePreferences } from 'src/app/interfaces/qr-code';

@Injectable({
  providedIn: 'root',
})
export class QrCodeService {
  constructor(private http: HttpClient) {}

  public saveQrCodePreferences(
    userId: number,
    petId: number,
    preferences: QrCodePreferences
  ): Observable<QrCodePreferences> {
    return this.http.post<QrCodePreferences>(
      `${environment.apiUrl}/api/qr-code-preferences/${userId}/${petId}`,
      preferences
    );
  }

  public getQrCodeData(
    petId: number,
    previewMode: boolean
  ): Observable<QrCodeData> {
    return this.http.get<QrCodeData>(
      `${environment.apiUrl}/api/qr-code/${petId}?previewMode=${previewMode}`
    );
  }

  public notify(petId: number, latitude: number, longitude: number) {
    const url = `${environment.apiUrl}/api/qr-code/${petId}/notify?latitude=${latitude}&longitude=${longitude}`;
    return this.http.post<any>(url, {}).subscribe(
      (res) => {},
      (err) => {
        console.error(err);
      }
    );
  }

  public getQrCodePreferencesForPet(
    petId: number
  ): Observable<QrCodePreferences> {
    return this.http.get<any>(
      `${environment.apiUrl}/api/qr-code-preferences/for-pet/${petId}`
    );
  }
}
